import type { SxProps, Theme } from '@mui/material'

export const messageContentSx = {
  fontSize: '0.875rem',
  lineHeight: 1.5,
  overflowWrap: 'anywhere',
  '& p': {
    margin: 0,
  },
  '& p + p': {
    marginTop: 1,
  },
  '& ul, & ol': {
    margin: 0,
    paddingLeft: 3,
  },
  '& table': {
    borderCollapse: 'collapse',
    my: 1,
  },
  '& td, & th': {
    border: 1,
    borderColor: 'divider',
    px: 1,
    py: 0.5,
    minWidth: 72,
    maxWidth: 240,
    verticalAlign: 'top',
    textAlign: 'left',
    overflowWrap: 'break-word',
  },
  '& th': {
    bgcolor: 'action.hover',
    fontWeight: 600,
  },
} satisfies SxProps<Theme>
